import React, { useState, useEffect } from 'react';
import './App.css';
import AppFooter from './components/Footer';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import Auth from './pages/Auth';
import PostDetail from './pages/PostDetail';
import Archive from './pages/Archive';
import About from './pages/About';
import WritePost from './pages/WritePost';
import AppHeader from './components/Header';

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  // 1. 文章数据持久化存储
  const [posts, setPosts] = useState(() => {
    const saved = localStorage.getItem('blogPosts');
    return saved ? JSON.parse(saved) : [];
  });

  // 初始化登录状态
  useEffect(() => {
    const savedUser = localStorage.getItem('loggedInUser');
    if (savedUser) setLoggedInUser(JSON.parse(savedUser));
  }, []);

  // 2. 监听 posts 变化，同步到 localStorage
  useEffect(() => {
    localStorage.setItem('blogPosts', JSON.stringify(posts));
  }, [posts]);

  // 3. 新增文章方法（修正方法名：与WritePost的props匹配）
  const handleAddPost = (newPost) => {
    setPosts(prev => [newPost, ...prev]); // 新文章置顶
  };

  // 4. 编辑文章方法
  const handleEditPost = (updatedPost) => {
    setPosts(prev => prev.map(post => post.id === updatedPost.id ? updatedPost : post));
  };

  // 5. 新增：删除文章方法（关键！传递给PostDetail）
  const handleDeletePost = (postId) => {
    setPosts(prev => prev.filter(post => post.id !== postId));
  };

  const handleLogin = (userData) => {
    setLoggedInUser(userData);
    localStorage.setItem('loggedInUser', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setLoggedInUser(null);
    localStorage.removeItem('loggedInUser');
  };

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <AppHeader loggedInUser={loggedInUser} onLogout={handleLogout} />
        </header>

        <main>
          <Routes>
            {/* 首页：传递 posts 数据 */}
            <Route 
              path="/" 
              element={loggedInUser ? <Home posts={posts} /> : <Navigate to="/auth" replace />} 
            />
            {/* 登录页 */}
            <Route path="/auth" element={<Auth onLogin={handleLogin} />} />
            {/* 文章详情页：传递 posts + loggedInUser + 删除回调 */}
            <Route 
              path="/post/:id" 
              element={loggedInUser ? (
                <PostDetail 
                  posts={posts} 
                  loggedInUser={loggedInUser} 
                  onDeletePost={handleDeletePost} // 传递删除方法
                />
              ) : (
                <Navigate to="/auth" replace />
              )} 
            />
            {/* 归档页：传递 posts 数据 */}
            <Route 
              path="/archive" 
              element={loggedInUser ? <Archive posts={posts} /> : <Navigate to="/auth" replace />} 
            />
            {/* 关于页 */}
            <Route 
              path="/about" 
              element={loggedInUser ? <About /> : <Navigate to="/auth" replace />} 
            />
            {/* 写文章页：传递正确的方法名 */}
            <Route 
              path="/write" 
              element={
                loggedInUser ? (
                  <WritePost 
                    onAddPost={handleAddPost} 
                    onEditPost={handleEditPost} 
                    loggedInUser={loggedInUser} 
                  />
                ) : (
                  <Navigate to="/auth" replace />
                )
              } 
            />
            {/* 404 页 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <AppFooter />
      </div>
    </Router>
  );
}

export default App;